import type { DeckCardKakaoKind } from "./deckCardKakaoKind";

type DeckCardKakaoI18nKeys = {
  shareTitle: string;
  shareAction: string;
  shareText: string;
  kakaoCardTitle: string;
  kakaoSenderLine: string;
  kakaoShortHint: string;
  kakaoOpenButton: string;
  expandShareBody: string;
};

export const DECK_CARD_SHARE_ACTION_DEFAULTS: Record<DeckCardKakaoKind, string> = {
  single: "Share single card",
  demo: "Share demo card",
  season: "Share season card",
  collection: "Share collection card",
  impact: "Share Impact Card",
};

const DECK_CARD_KAKAO_I18N: Record<DeckCardKakaoKind, DeckCardKakaoI18nKeys> = {
  single: {
    shareTitle: "single_card_share_title",
    shareAction: "single_card_share_action",
    shareText: "single_card_share_text",
    kakaoCardTitle: "single_card_kakao_card_title",
    kakaoSenderLine: "single_card_kakao_sender_line",
    kakaoShortHint: "single_card_kakao_short_hint",
    kakaoOpenButton: "single_card_kakao_open_button",
    expandShareBody: "single_card_expand_share_body",
  },
  demo: {
    shareTitle: "demo_card_share_title",
    shareAction: "demo_card_share_action",
    shareText: "demo_card_share_text",
    kakaoCardTitle: "demo_card_kakao_card_title",
    kakaoSenderLine: "demo_card_kakao_sender_line",
    kakaoShortHint: "demo_card_kakao_short_hint",
    kakaoOpenButton: "demo_card_kakao_open_button",
    expandShareBody: "demo_card_expand_share_body",
  },

  season: {
    shareTitle: "season_card_share_title",
    shareAction: "season_card_share_action",
    shareText: "season_card_share_text",
    kakaoCardTitle: "season_card_kakao_card_title",
    kakaoSenderLine: "season_card_kakao_sender_line",
    kakaoShortHint: "season_card_kakao_short_hint",
    kakaoOpenButton: "season_card_kakao_open_button",
    expandShareBody: "season_card_expand_share_body",
  },
  collection: {
    shareTitle: "collection_card_share_title",
    shareAction: "collection_card_share_action",
    shareText: "collection_card_share_text",
    kakaoCardTitle: "collection_card_kakao_card_title",
    kakaoSenderLine: "collection_card_kakao_sender_line",
    kakaoShortHint: "collection_card_kakao_short_hint",
    kakaoOpenButton: "collection_card_kakao_open_button",
    expandShareBody: "collection_card_expand_share_body",
  },
  impact: {
    shareTitle: "impact_card_share_title",
    shareAction: "impact_card_share_action",
    shareText: "impact_card_share_text",
    kakaoCardTitle: "impact_card_kakao_card_title",
    kakaoSenderLine: "impact_card_kakao_sender_line",
    kakaoShortHint: "impact_card_kakao_short_hint",
    kakaoOpenButton: "impact_card_kakao_open_button",
    expandShareBody: "impact_card_expand_share_body",
  },
};

export const getDeckCardKakaoI18nKeys = (kind: DeckCardKakaoKind): DeckCardKakaoI18nKeys =>
  DECK_CARD_KAKAO_I18N[kind];
